// extracted by mini-css-extract-plugin
export var growableInput = "_9p-0";
export var tagContainer = "_9p-2";
export var textInput = "_9p-1";